export const SET_PRESIGNED_URL = 'SET_PRESIGNED_URL'
export const SET_PARSING_OPTIONS = 'SET_PARSING_OPTIONS'
export const SET_SHEET = 'SET_SHEET'
export const CLEAR_UPLOAD_DATA = 'CLEAR_UPLOAD_DATA'
